import { Injectable } from '@angular/core';
import {AppConfig} from '../app.config';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  public createOrderUrl = this.config.baseUrl + 'api/order';
  public verifyUrl = this.config.baseUrl + 'api/payment/verify';
  public discountUrl = this.config.baseUrl + 'api/coupon/validation';
  constructor(public config: AppConfig, public http: HttpClient) { }
  storePlan(plan: any): Observable<any> {
    const options = {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      }
    };
    // @ts-ignore
    return this.http.post(this.createOrderUrl, plan, options).pipe(map((response: Response) => {
      return response;
    }));
  }
  verify(order: any): Observable<any> {
    const options = {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      }
    };
    // @ts-ignore
    return this.http.post(this.verifyUrl, order , options).pipe(map((response: Response) => {
      return response;
    }));
  }
  verifyDiscount(order: any): Observable<any> {
    const options = {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      }
    };
    // @ts-ignore
    return this.http.post(this.discountUrl, order , options).pipe(map((response: Response) => {
      return response;
    }));
  }
}
